import { v4 as uuidv4 } from 'uuid';

class Event {

    constructor({ id, userID, situationID, time, type, duration }) {
        this.id = id ? id : uuidv4();
        Object.assign(this, { userID, situationID });
        this.type = type ? type : "Event";
        this.time = time ? time : Date.now();
        this.duration = duration ? duration : 1000
    }

    getType() { return this.type; }

    setID(id) { this.id = id; return this; }
    getID() { return this.id; }

    setUserID(id) { this.userID = id; return this; }
    getUserID() { return this.userID; }

    setSituationID(id) { this.situationID = id; return this; }
    getSituationID() { return this.situationID; }

    setTime(time) { this.time = time; return this; }
    getTime() { return this.time; }

    setDuration(duration) { this.duration = duration; return this; }
    getDuration() { return this.duration; }

    isOfType(type) {
        return type === this.type;
    }

    parseFromJSON(json) {
        if (json && json.id) {
            this
                .setID(json.id)
                .setUserID(json.userID)
                .setSituationID(json.situationID)
                .setTime(json.time)
                .setDuration(json.duration)
        } else {
            console.error("Trying to parse unknown event type");
        }
        return this;
    }
}

class NotifyPositionEvent extends Event {
    constructor({ id, userID, situationID, time, duration,
        position,
        rotation,
        color
    } = {}) {
        super({ id, userID, situationID, time, duration, type: "NotifyPositionEvent" });
        Object.assign(this, { position, rotation, color });
    }

    isOfType(type) {
        return type === this.type || super.isOfType(type);
    }

    setPosition(pos) { this.position = pos; return this; }
    getPosition() { return this.position; }

    setRotation(rot) { this.rotation = rot; return this; }
    getRotation() { return this.rotation; }

    setColor(color) { this.color = color; return this; }
    getColor() { return this.color; }

    parseFromJSON(json) {
        if (json && json.id) {
            super.parseFromJSON( json )
                .setPosition(json.position)
                .setRotation(json.rotation)
                .setColor(json.color)
        } else {
            console.error("Trying to parse unknown event type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new NotifyPositionEvent().parseFromJSON( json );
    }    
}

class EventBuilder {
    constructor() {
        this.supportedEventTypes = new Map();
    }

    registerEventType( event ) {
        if( event.getType ) {
            this.supportedEventTypes.set( event.getType(), event );
        }
    }

    createFromJSON( json ) {
        if( json && json.type ) {
            console.log("Trying to instantiate an event for type " + json.type);
            if( this.supportedEventTypes.has( json.type ) )        
                return this.supportedEventTypes.get( json.type ).createFromJSON( json );
            else
                console.log("Unknown event type " + json.type );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown event type ");
        }
    }
}

const EventBuilderInstance = new EventBuilder();
Object.freeze(EventBuilderInstance);

EventBuilderInstance.registerEventType( new NotifyPositionEvent() );

export { Event, EventBuilder, EventBuilderInstance, NotifyPositionEvent }
